/*
 * Copyright (c) 2022. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { useEffect, useMemo } from 'react';

const DEFAULT_PAGE_TITLE = 'PowerAlpha';

const slice = (str: string) => (str.length > 20 ? `${str.slice(0, 20)}...` : str);

interface PageTitleOptions {
  projectName?: string | null;
  opptyName?: string | null;
  bidRequestName?: string | null;
  componentName?: string | null; // or
  scenarioId?: string | null; // or
  workflowId?: string | null; // or
  configName?: string | null; // and
  configVersion?: number | null;
}

export const usePageTitle = (title: string, opts?: PageTitleOptions) => {
  const titlePrefix = useMemo(() => {
    let pre = '';
    if (opts?.projectName) {
      pre = `${slice(opts.projectName)} (P) `;
    }
    if (opts?.opptyName) {
      pre = `${slice(opts.opptyName)} (O) `;
    }
    if (opts?.bidRequestName) {
      pre = `${slice(opts.bidRequestName)} (BR) `;
    }
    return pre;
  }, [opts?.bidRequestName, opts?.opptyName, opts?.projectName]);

  const titlePostfix = useMemo(() => {
    if (opts?.componentName) {
      return ` - ${opts.componentName}`;
    }
    if (opts?.scenarioId) {
      return ` - Scenario ${opts.scenarioId.slice(0, 5)}`;
    }
    if (opts?.workflowId) {
      return ` - Workflow ${opts.workflowId.slice(0, 5)}`;
    }
    if (opts?.configName && opts?.configVersion) {
      return ` - Config ${opts.configName} v${opts.configVersion}}`;
    }
    return '';
  }, [
    opts?.componentName,
    opts?.configName,
    opts?.configVersion,
    opts?.scenarioId,
    opts?.workflowId,
  ]);

  useEffect(() => {
    document.title = `${titlePrefix}${title}${titlePostfix}`;

    return () => {
      document.title = DEFAULT_PAGE_TITLE;
    };
  }, [title, titlePostfix, titlePrefix]);
};
